import {fetchData} from "./helpers";

(function ($) {

    const body = $("body");
    body.on( 'click', '.quantity-wrap button.quantity-plus', function() {
        const quantity = $(this).parent().find('.qty');
        const value = parseInt(quantity.val());
        if (quantity.attr('max')) {
            if (quantity.attr('max') > value) {
                quantity.val(value + 1);
            }
        } else if (value < 99) {
            quantity.val(value + 1);
        }
        cartUpdate();
    });

    body.on( 'click', '.quantity-wrap button.quantity-minus', function() {
        const quantity = $(this).parent().find(".qty");
        const value = parseInt(quantity.val());
        if (quantity.attr('min')) {
            if (quantity.attr('min') < value) {
                quantity.val(value - 1);
            }
        } else if (value > 1) {
             quantity.val(value - 1);
        }

        cartUpdate();
    });

    body.on( 'change input', '.quantity-wrap input', function() {
        setTimeout(() => cartUpdate(), 100);
    });

    $('.quantity .qty').on('change input', function () {
        $(this).closest('.product').find('.ajax_add_to_cart').attr('data-quantity', $(this).val());
    });

    function cartUpdate() {
        const button = $('[name="update_cart"]');
        button.attr('disabled', false);
        button.trigger('click');
    }

    $(document).on('change', '.additional-service-item input', function() {
        body.trigger('update_checkout');
        const input = $(this);

        $('.additional-service-item input').each(function() {
            if (input.attr('name') !== $(this).attr('name')) {
                $(this).prop('checked', false);
            }
        });

        const hasChecked = $('.additional-service-item input:checked').length > 0;
        if (hasChecked) {
            $('.tire-insurance').css('display', '');
        } else {
            $('.tire-insurance').css('display', 'none');
            $('.tire-insurance input').prop('checked', false);
        }
    });

    $(document).on('change', '.tire-insurance input', function() {
        body.trigger('update_checkout');

        if ($(this).prop('checked')) {
            $('#number_plate_field').removeClass('hidden');
        } else {
            $('#number_plate_field').addClass('hidden');
        }
    });

    $(document).on( 'updated_checkout', function() {
        setTimeout(function() {
            $('.woocommerce-shipping-totals.shipping #storelist').remove();
        }, 200);
    });

    $(document).on('change', '#storelist', function() {
        const storeId = $(this).find(':selected').data('id');
        $('.additional-service-item input').each(function() {
            const prices = $(this).data('prices');
            $(this).parent('li').find('.cost').html('<span class="woocommerce-Price-amount amount"><bdi>'+prices[storeId].total_price.toFixed(2)+'<span class="woocommerce-Price-currencySymbol">kr/stk</span></bdi></span>');
        });
    });

    $('.ajax_add_to_cart').click(function(e) {
        if ( !$(this).hasClass('product_type_variable') ) {
            e.stopPropagation();
            e.preventDefault();

            const productId = $(this).attr('data-product_id');
            const quantity = $(this).parent().find('.qty').val();
            const data = {};
            if (productId) data['product_id'] = productId;
            if (quantity) data['quantity'] = quantity;

            buildCartModal(data);
        }
    });

    $('.single_add_to_cart_button').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        const variationId = $('input[name="variation_id"]').val();
        const productId = variationId ? $('input[name="product_id"]').val() : $(this).val();
        const quantity = $('.qty').val();

        const data = {};
        if (productId) data['product_id'] = productId;
        if (variationId) data['variation_id'] = variationId;
        if (quantity) data['quantity'] = quantity;

        buildCartModal(data);
    });

    $('.configurator_add_to_cart').click(function(e) {
        e.stopPropagation();
        e.preventDefault();

        const data = {};
        const products = $(this).attr('data-products');
        if (products) {
            data['products'] = products;
        }

        buildCartModal(data);
    });

    function buildCartModal(data) {

        const modalBody = $('.woocommerce-cart-modal .modal-body');
        modalBody.slideUp('fast');
        $('.woocommerce-cart-modal').css('display', 'flex');

        fetchData('add_to_cart_product_ajax', data, function(result) {

            if (result['status'] !== 'success') {
                return;
            }

            $('.woocommerce-cart-modal .modal-body-inner').html(result['data']);

            modalBody.slideDown('fast');
            $(document.body).trigger( 'wc_fragment_refresh' );
        });
    }

    $(document.body).trigger( 'wc_fragment_refresh' );

    $(document).on( 'change', '#shipping_method input[type="radio"]', function() {
        $('.billing-dynamic').toggleClass('hidden', this.value === 'free_pickup');
    });

    $('form.checkout.woocommerce-checkout').bind('DOMSubtreeModified', function(){
        const ul = $('ul.woocommerce-error');
        if (ul.length) {
            ul.insertAfter('.woocommerce-notices-wrapper');
        }
    });

    $('.woocommerce-form-login-toggle').on('click', function() {
        const accountPassword = $('.customer-info-fields-list #account_password_field');
        const accountPasswordConfirm = $('.customer-info-fields-list #account_password_confirm_field');

        if ($('#checkout-customer:checked').length) {
            accountPassword.css('display', 'block');
            accountPasswordConfirm.css('display', 'block');
        } else  {
            accountPassword.css('display', 'none');
            accountPasswordConfirm.css('display', 'none');
        }
    });

    $(":input:not([name='account_type'])").on('change',function() {
        $('input[name="' + this.name + '"]').val($(this).val());
    });

    $(window).click(() => {
        $('.instruction-image').css('display', 'none');
    });

    $('#show-info-image').click((e) => {
        e.stopPropagation();
        $('.instruction-image').css('display', 'block');
    });

    fetchData('get_cart_count_ajax', [], function(result) {
        if (result['data']) {
            jQuery('.cart-contents-count').replaceWith(result['data']);
        }
    });

})(jQuery);